// extracted by mini-css-extract-plugin
module.exports = {"PriorityIcon":"FaultsTable_PriorityIcon__1L-iK","Table":"FaultsTable_Table__2wVez","Pager":"FaultsTable_Pager__1lo2H","KendoTreeList":"FaultsTable_KendoTreeList__2b5iY"};